import * as yup from 'yup';

export const HelpCenterFormValidation = yup
  .object({
    fullName: yup.string().required('Please enter your name'),
    text: yup.string().required('Please enter your message'),
  });
